<template>
    <view-contragent-list
        :findText="findText"
        :toolbarShow="false"
        :filterPanelShow="false"
        :selectionMode="'single'"
        :totalCountSelectedShow="false"
        :filterRow="{ visible: false }"
    ></view-contragent-list>
</template>
<script>
export default {
    name: 'view-contragent-list-search',
};
</script>
<script setup>
import { defineProps } from 'vue';

defineProps({
    findText: { default: '', type: [String] },
});
</script>
